import React from "react";
import { motion } from "framer-motion";

export default function SignUpCTASection({ theme = "light", returnPath = "/GiveawayCopy", sectionRef, onLoginClick, config }) {

  return (
    <section
      ref={sectionRef}
      dir="rtl"
      style={{ background: "#111", padding: "60px 16px", position: "relative", overflow: "hidden" }}
    >
      <div className="mx-auto" style={{ maxWidth: "90%" }}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden"
          style={{ borderRadius: "30px", minHeight: "490px", background: "#000" }}
        >
          {/* Background image */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url('${config?.bg_image ?? "/images/giveaway/cta_golden_bg.png"}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.5,
            }}
          />

          {/* Glow overlay */}
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            style={{ width: "600px", height: "320px", background: "rgba(200,241,53,0.06)", filter: "blur(50px)", borderRadius: "230px" }}
          />

          {/* Content */}
          <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 py-20 gap-11">
            {/* Text block */}
            <div className="flex flex-col items-center gap-1" style={{ maxWidth: "637px" }}>
              <h2
                className="font-bold text-white"
                style={{ fontSize: "44.8px", lineHeight: "56px" }}
              >
                {config?.heading ?? "אם הגעתם עד לכאן, אין ספק שאתם חברי הקהילה החדשים"}
              </h2>
              <p
                style={{ fontSize: "16px", lineHeight: "24px", color: "#C4C4C4", fontWeight: 400 }}
              >
                {config?.body ?? "הירשמו לחשבון חינמי, בצעו משימות ברשתות שלנו, וצברו כמה שיותר נקודות."}
              </p>
              <p
                className="mt-2 font-semibold"
                style={{ fontSize: "16px", lineHeight: "24px", color: "#C8F135" }}
              >
                הרשמה ב-₪0 – ללא שום התחייבות.
              </p>
            </div>

            {/* Button + note */}
            <div className="flex flex-col items-center gap-4">
              <button
                onClick={() => { window.location.href = "/account/sign-up"; }}
                className="inline-flex items-center justify-center transition-all duration-200 active:scale-[0.98]"
                style={{
                  background: "#C8F135",
                  color: "#000",
                  boxShadow: "0px 8px 36px rgba(200, 241, 53, 0.35)",
                  borderRadius: "9999px",
                  width: "295px",
                  height: "60px",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                {config?.button_text ?? "קחו אותי למשימה הראשונה!"}
              </button>
              <p style={{ fontSize: "14px", lineHeight: "24px", color: "#C4C4C4", fontWeight: 400 }}>
                {config?.disclaimer ?? "סיום האתגר: התוצאות יוכרזו ב-31.3.2026 (הכרטיסים אישיים ואינם ניתנים להעברה)."}
              </p>
              <button
                onClick={() => onLoginClick ? onLoginClick() : (window.location.href = "/account/login")}
                className="text-sm underline transition-colors"
                style={{ color: "#C8F135", background: "none", border: "none", cursor: "pointer" }}
              >
                כבר רשומים? התחברו כאן להמשך צבירת הנקודות.
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}